import React from 'react';
import Load from 'components/Load';
import basePath from 'utils/basePath';
import NavigationableLayout from 'modules/app/components/NavigationableLayout';

const AsyncFeatureFlags = Load(() => import(/* webpackChunkName: "feature-flags" */'./components/FeatureFlags'), {}, true);

const FeatureFlagRoute = (
  <NavigationableLayout
    path={`${basePath}/feature-flags`}
    component={AsyncFeatureFlags}
    nonFixedNavbar
  />
);

export default FeatureFlagRoute;
